module.exports = __webpack_public_path__ + "img/too-much-fog_2022-01-10.png";